import { render, staticRenderFns } from "./NotificationCardOne.vue?vue&type=template&id=67616dcc"
import script from "./NotificationCardOne.vue?vue&type=script&lang=js"
export * from "./NotificationCardOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports